import { IndicatorComponent } from './indicator/indicator.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, Output, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, Subscription } from 'rxjs';
import { SortHelper } from '../../helpers/sort.helper';
import { Indicator, IndicatorStatus } from './models/indicator.model';
import _cloneDeep from 'lodash/cloneDeep';
import { Utils } from 'formiojs';
import { FormioLoader, FormioCustomComponent, ResourceNameService } from 'dp-formio';

@Component({
  selector: 'app-indicators-wrapper',
  templateUrl: './indicators-wrapper.component.html',
  // styleUrls: ['./indicators-wrapper.component.scss']
  encapsulation: ViewEncapsulation.None,
  providers: [FormioLoader]
})
export class IndicatorsWrapperComponent implements FormioCustomComponent<any>, OnDestroy, OnChanges {
  dir: 'rtl' | 'ltr';
  @Input() required: boolean;

  @Input()
  value: any = {};

  @Output()
  valueChange = new EventEmitter<any>();

  @Input()
  disabled: boolean;

  @Input()
  viewOnly: boolean;

  @Input()
  data: any;

  @Input()
  customOptions: any;

  @Input()
  formioComponent: any;

  query = ``;
  indicators: Indicator[] = [];
  indicatorStatus = IndicatorStatus;

  hideSummary: boolean;

  hideQuestions: boolean;
  hideAttachments: boolean;
  hideNotes: boolean;
  hideRecommendations: boolean;
  hideDecision: boolean;
  hideSaveDomain: boolean;

  disableQuestions: boolean;
  disableAttachments: boolean;
  disableNotes: boolean;
  disableRecommendations: boolean;
  disableDecision: boolean;

  private subs: Subscription[] = [];
  set sub(s: Subscription) { this.subs.push(s); }

  constructor(private translateService: TranslateService,
    private resourceNameService: ResourceNameService,
    private matDialog: MatDialog,
    private formioLoader: FormioLoader) {
    this.changeDirection(this.translateService.currentLang);
    this.sub = this.translateService.onLangChange.subscribe(data => {
      this.changeDirection(data.lang);
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.customOptions && this.customOptions.resource) {
      this.query = this.formioComponent.interpolate(this.customOptions.query, { data: this.data });

      this.hideSummary = eval(this.formioComponent.interpolate(this.customOptions.hideSummary, { data: this.data }));

      this.hideQuestions = eval(this.formioComponent.interpolate(this.customOptions.hideQuestions, { data: this.data }));
      this.hideAttachments = eval(this.formioComponent.interpolate(this.customOptions.hideAttachments, { data: this.data }));
      this.hideNotes = eval(this.formioComponent.interpolate(this.customOptions.hideNotes, { data: this.data }));
      this.hideRecommendations = eval(this.formioComponent.interpolate(this.customOptions.hideRecommendations, { data: this.data }));
      this.hideDecision = eval(this.formioComponent.interpolate(this.customOptions.hideDecision, { data: this.data }));
      this.hideSaveDomain = eval(this.formioComponent.interpolate(this.customOptions.hideSaveDomain, { data: this.data }));

      this.disableQuestions = eval(this.formioComponent.interpolate(this.customOptions.disableQuestions, { data: this.data }));
      this.disableAttachments = eval(this.formioComponent.interpolate(this.customOptions.disableAttachments, { data: this.data }));
      this.disableNotes = eval(this.formioComponent.interpolate(this.customOptions.disableNotes, { data: this.data }));
      this.disableRecommendations = eval(this.formioComponent.interpolate(this.customOptions.disableRecommendations, { data: this.data }));
      this.disableDecision = eval(this.formioComponent.interpolate(this.customOptions.disableDecision, { data: this.data }));

      this.getIndicatorsResources();
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
    this.subs = [];
  }

  openIndicator(indicator: Indicator, isSummary = false) {
    const dialog = this.matDialog.open(IndicatorComponent, {
      data: {
        dir: this.dir,
        submission: this.data,
        indicator: _cloneDeep(indicator),
        customOptions: this.customOptions,
        viewOnly: this.viewOnly,
        isSummary: isSummary,
        options: {
          hideQuestions: this.hideQuestions,
          hideAttachments: this.hideAttachments,
          hideNotes: this.hideNotes,
          hideRecommendations: this.hideRecommendations,
          hideDecision: this.hideDecision,
          hideSaveDomain: this.hideSaveDomain,
          disableQuestions: this.disableQuestions,
          disableAttachments: this.disableAttachments,
          disableNotes: this.disableNotes,
          disableRecommendations: this.disableRecommendations,
          disableDecision: this.disableDecision
        }
      },
      height: '100vh',
      width: '100vw',
      panelClass: 'full-screen-modal',
      disableClose: true
    });
    const sub = dialog.afterClosed().subscribe(result => {
      sub.unsubscribe();
      if (result) {
        this.indicators[this.indicators.findIndex(q => q.id == result.id)] = result;
        this.notifyValue();
      }
    });
  }

  private notifyValue(updateBaseForm = true) {
    this.value = { indicatorsData: this.indicators.map(q => q.id) };
    this.valueChange.emit(this.value);
    this.afterChangeValue(updateBaseForm);
  }

  private afterChangeValue(updateBaseForm = true) {
    if (this.customOptions && this.customOptions.afterChange)
      this.customOptions.afterChange.forEach(item => {
        const mustUpdateValues = eval(this.formioComponent.interpolate(item.condition, { data: this.data }));
        if (mustUpdateValues) {
          const components = Utils.searchComponents(this.formioComponent.root.components, { key: item.key });
          components.forEach(c => {
            const value = this.formioComponent.interpolate(item.value, { data: this.data, indicators: this.indicators, indicatorStatus: this.indicatorStatus });
            c.setValue(value);
            c.checkCondition();
          });

          const nestedForms = Utils.searchComponents(this.formioComponent.root.components, { type: 'form' });
          nestedForms.forEach(formComponent => {
            formComponent.subFormReady.then((subForm) => {
              Utils.eachComponent(subForm.components, (component) => {
                if (component.key == item.key) {
                  const value = this.formioComponent.interpolate(item.value, { data: this.data, indicators: this.indicators, indicatorStatus: this.indicatorStatus });
                  component.setValue(value);
                  component.checkCondition();
                }
              }, true);
            });
          });
        }
      });
  }

  private changeDirection(lang) {
    this.dir = null;
    setTimeout(() => { this.dir = lang === 'ar' ? 'rtl' : 'ltr'; });
  }

  private getIndicatorsResources() {
    if (!this.formioComponent.visible) return;
    this.formioLoader.loading = true;

    //todo this two line just for test
    // this.formioComponent.data.requestId = 500;
    // this.formioComponent.data.submissionId = '6176a990e4f0395c57b16ce1';

    this.sub = this.resourceNameService.loadCustomByFilterdKey(this.customOptions.resource, this.query).pipe(
      map((resultData: any) => {
        return SortHelper.recursiveSort(resultData, 'asc').map(q => {
          const item = new Indicator(q._id, q.data.key, q.data.icon, q.data.order);
          item.attachmentsFormKey = this.customOptions.attachmentsForm;
          item.requestId = this.formioComponent.data.varRequestId;
          item.submissionId = this.formioComponent.data.varSubmissionId;
          return item;
        })
      }))
      .subscribe(data => {
        if (data && data.length) {
          const indicatorsId = data.map(q => q.id).join();
          const query = `data.requestId=${data[0].requestId}&data.indicatorId__in=${indicatorsId}`;
          this.sub = this.resourceNameService.loadCustomByFilterdKey(this.customOptions.indicatorResult, query)
            .subscribe(indicators => {
              indicators.forEach(q => {
                const index = data.findIndex(d => d.id == q.data.indicatorId);
                if (index >= 0) {
                  data[index].status = q.data.status;
                  data[index].resultSubmissionId = q._id;
                }
              });
              this.indicators = data;
              console.log(this.indicators);
              this.notifyValue(false);
              this.formioLoader.loading = false;
            }, error => {
              this.formioLoader.loading = false;
            });
        }
      }, error => {
        this.formioLoader.loading = false;
      });
  }
}
